import React from 'react';

import styles from './content.scss';

const Content = ({children}) =>
  <div className="content">
    {children}
  </div>

export default Content;



// WEBPACK FOOTER //
// ./src/components/layout/Content.js